import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ActiveAgentsComponent } from './main-widgets/active-agents/active-agents.component';
import { SingleAgentComponent } from './main-widgets/active-agents/single-agent/single-agent.component';
import { VoilationHistoryComponent } from './main-widgets/voilation-history/voilation-history.component';
import { ChatComponent } from './main-widgets/chat/chat.component';
import { ViolationApprovalComponent } from './floating-widgets/violation-approval/violation-approval.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MapComponent } from './map/map.component';
import { LoginComponent } from './main-widgets/login/login.component';
import { ViolationCountComponent } from './main-widgets/violation-count/violation-count.component';
import { TotalAgentTimeComponent } from './main-widgets/total-agent-time/total-agent-time.component';
import { MainsuperAdminComponent } from '../super-admin/main-widgets/mainsuper-admin/mainsuper-admin.component';
import { ApproveVoilationComponent } from '../super-admin/main-widgets/approve-voilation/approve-voilation.component';
import { VoilationListComponent } from '../super-admin/main-widgets/voilation-list/voilation-list.component';
import { ViolationFilterPipe } from '../super-admin/main-widgets/violationPipes/violation-filter.pipe';
import { pendingTimePipe } from './main-widgets/pipes/pending-time.pipe';
import { EventsFilterComponent } from './floating-widgets/events-filter/events-filter.component';
import { DashboardComponent } from './main-widgets/dashboard/dashboard.component';
import { GamificationComponent } from './main-widgets/gamification/gamification.component';
import { NgImageFullscreenViewModule } from 'ng-image-fullscreen-view';
import { NgxPaginationModule } from 'ngx-pagination';
import { ErrorComponent } from './error/error.component';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { SecureAssistDetailsPopupComponent } from './floating-widgets/secure-assist-details-popup/secure-assist-details-popup';
import { TreeviewModule } from 'ngx-treeview';
import { WebRTCScreenSelectionPopupComponent } from './floating-widgets/webrtc-screen-selection-popup/webrtc-screen-selection-popup';
import { FilterComponent } from './floating-widgets/unified-global-filters/unified-global-filters';
import { ScreenGlanceDetailsPopupComponent } from './floating-widgets/screen-glance-details-popup/screen-glance-details-popup';

@NgModule({

  declarations: [
    SingleAgentComponent,
    VoilationHistoryComponent,
    ChatComponent,
    ViolationApprovalComponent,
    ActiveAgentsComponent,
    MapComponent,
    LoginComponent,
    ViolationCountComponent,
    TotalAgentTimeComponent,
    MainsuperAdminComponent,
    ApproveVoilationComponent,
    VoilationListComponent,
    ViolationFilterPipe,
    pendingTimePipe,
    EventsFilterComponent,
    DashboardComponent,
    GamificationComponent,
    ErrorComponent,
    SecureAssistDetailsPopupComponent,
    WebRTCScreenSelectionPopupComponent,
    FilterComponent,
    ScreenGlanceDetailsPopupComponent,
  ],
  exports: [
    ActiveAgentsComponent, VoilationHistoryComponent,
    ChatComponent, ViolationApprovalComponent,
    MapComponent, TotalAgentTimeComponent,
    SecureAssistDetailsPopupComponent
  ],
  providers: [ActiveAgentsComponent, DatePipe,],
  imports: [
    CommonModule, ReactiveFormsModule, FormsModule, NgImageFullscreenViewModule,
    NgxPaginationModule, PickerModule, TreeviewModule.forRoot(),
  ]
})
export class CoreModule { }
